import { useState } from 'react';
import styled from 'styled-components';
import Modal from '~~elements/Modal';
import { PHONE_WIDTH, getNameDisplay } from '~~elements/Const';
import Button from '~~elements/Button';
import Input from '~~elements/Input';
import toast from '~~elements/Toast';
import { UserResource, PlayerResource } from '~~apis/resource';
import TTMultilingual from './Multilingual';

const StyledDiv = styled.div`
  width: 100%;
  color: black;
  white-space: pre-line;
  hr {
    width: 100%;
    border-top: 1px solid gray;
  }

  .permission {
    &--item {
      padding: 0.2rem 0;
      display: grid;
      grid-template-columns: 3fr 2fr;
      align-items: center;
    }
  }
  @media (max-width: ${PHONE_WIDTH}) {
    .permission {
      &--item {
        grid-template-columns: 1fr;
        text-align: center;
      }
    }
  }
`;

const AssignPlayerManager = ({ player, isOpen, toClose, claimedCallback }) => {
  const [managerQuery, setManagerQuery] = useState('');
  const [manager, setManager] = useState({ name: '', uniqid: '' });

  const handleQueryUpdate = (e) => setManagerQuery(e.target.value);

  const handleManagerCheck = () => {
    let query = { email: managerQuery };
    if (!managerQuery.match(/@/)) {
      query = { userName: managerQuery };
    }
    UserResource.exists(query).then(({ data }) => {
      if (!data.exists) {
        toast(TTMultilingual(`ERROR.MANAGER_NOT_FOUND`), { status: 'error', second: 3 });
        return;
      }

      return setManager({ name: getNameDisplay(data.first_name, data.last_name), uniqid: data.uniqid });
    });
  };

  const cancelManager = () => {
    setManager({ name: '', uniqid: '' });
  };

  const handleManagerSubmit = () => {
    PlayerResource.updatePermission({ userUniqid: manager.uniqid, playerUniqid: player.uniqid, authority: 'ADMIN' })
      .then(() => {
        toast(TTMultilingual(`SUCCESSFULLY_ASSIGN`), { status: 'success', second: 1 });
        claimedCallback(player.uniqid);
        toClose();
      })
      .catch(() => {
        toast(TTMultilingual(`COMMON.UNKNOWN_ERROR`), { status: 'error', second: 2 });
      });
  };

  return (
    <Modal.Modal isOpen={isOpen} onClickBack={toClose}>
      <Modal.ModalHeader hasBack={true} onClickBack={toClose}>
        {TTMultilingual(`ASSIGN_MANAGER`)}
      </Modal.ModalHeader>
      <Modal.ModalBody>
        <StyledDiv>
          <div>{TTMultilingual(`ASSIGN_DESCRIPTION`)}</div>
          <h3>{`${player.name} #${player.number}`}</h3>
          <hr />
          <div className="permission--item">
            <Input
              placeholder={TTMultilingual(`ASSIGN_QUERY_HINT`)}
              value={managerQuery}
              onChange={handleQueryUpdate}
              textAlign="left"
            />
            <div>
              {manager.uniqid ? (
                <>{manager.name}</>
              ) : (
                <Button mini width="unset" nowrap color="transparent" onClick={handleManagerCheck}>
                  {TTMultilingual(`MANAGER_CHECK`)}
                </Button>
              )}
            </div>
          </div>
        </StyledDiv>
      </Modal.ModalBody>
      <Modal.ModalFooter>
        {manager.uniqid && (
          <div>
            <Button width="unset" nowrap onClick={handleManagerSubmit}>
              {TTMultilingual(`ASSIGN_CONFIRM`)}
            </Button>
            <Button width="unset" nowrap color="transparent" onClick={cancelManager}>
              {TTMultilingual(`COMMON.CANCEL`)}
            </Button>
          </div>
        )}
      </Modal.ModalFooter>
    </Modal.Modal>
  );
};

export default AssignPlayerManager;
